import { NarrativeConstants } from '../store/narrative.constants'

export const narrativeSchemas = [
  {
    inputKey: NarrativeConstants.SET_NARRATIVE_TEXT,
    isNumber: false,
    type: 'object',
    properties: {
      SET_NARRATIVE_TEXT: {
        type: 'string',
        pattern: '^([\x00-\x7F\xA0-\xFF]){1,10000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_NARRATIVE_TEXT'],
    errorMessage: {
      properties: {
        SET_NARRATIVE_TEXT: 'Must be alphanumeric with max length of 10000',
      },
    },
  },
]
